import axios from "./axios_interceptor";
import { store } from "../state/store";
import { get_jwt_token, loginRedirect } from "./helper_funtions";
import { showError,showErrorMsg } from "../utils/showMessage";

export const GetAdvanceData = async (
  page,
  perPage,
  status,
  from_date,
  to_date,
  path,
) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const search = "";
    const filterBy = "advance";
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    path = "active-usage";
    let url = `/audits/${path}/?page=${page}&limit=${perPage}&search=${search}&filter_by=${filterBy}&status=${status}&from_date=${from_date}&to_date=${to_date}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const GetAdvanceDataUser = async (
  email,
  from_date,
  to_date,
  page,
  perPage,
  path,
) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const search = "";
    const filterBy = "advance";
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const statuss = "";
    let url = `/audits/${path}/?page=${page}&limit=${perPage}&search=${search}&filter_by=${filterBy}&email=${email}&status=${statuss}&from_date=${from_date}&to_date=${to_date}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAppsAccessReportData = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let url = `/audits/apps-access/?page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAssetsAccessReportData = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let url = `/audits/assets-access/?page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const liveuserslist = async (data, managedCustomerId = null) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        ...(managedCustomerId ? { "X-Customer-ID": managedCustomerId } : {}),
      },
    };
    let url = `/users/live/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getMostActiveUserDetails = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let url = `/audits/active-user-detail/?username=${data.username}&page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getAuditsCsv = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/audits/export-audit-csv/?report_type=${data.report_type}`;
    const response = await axios.get(url, config);
    return { data: response, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getReportsData = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let url = `/audits/generate-reports/?page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&report_type=${data.report_type}&response_type=${data.response_type}&filter_by=${data.filter_by}`;
    if (data.advance_filters && data.advance_filters !== "") {
      url += `&${data.advance_filters}`;
    }
    url += `&time_zone=${clientTimezone}`;

    if (data.columns && Array.isArray(data.columns)) {
      data.columns.forEach((col) => {
        url += `&columns=${col}`;
      });
    }

    const response = await axios.get(url, config);
    if (response && response.data) {
      if (data.response_type === "table") {
        return { data: response.data, error: null };
      } else {
        return { data: response, error: null };
      }
    } else {
      showErrorMsg("Invalid Response Type");
    }
  } catch (e) {
    return {
      data: null,
      error: e.response ? e.response?.data?.errors || e.message || "An error occurred" : e.message,
    };
  }
};

export const getFieldsData = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let url = `/audits/distinct-elements-search/?field_name=${
      data.field_name
    }&page_size=${data.page_size}&page=${data.page ? data.page : 1}&search_query=${
      data.search_query
    }&report_type=${data.report_type}${
      data.start_time ? "&start_time=" + data.start_time : ""
    }${data.end_time ? "&end_time=" + data.end_time : ""}${
      data.added_query ? "&" + data.added_query : ""
    }`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getRdpCommandsByAccessId = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    // Use the mopam service with Django ORM endpoint
    let url = `/audits/rdp-handlers-by-access-id/?access_id=${data.access_id}`;
    if (data.page) url += `&page=${data.page}`;
    if (data.limit) url += `&limit=${data.limit}`;
    if (data.search) url += `&search=${data.search}`;

    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    console.log(e);
    return { data: null, error: e.response?.data?.errors || e.message };
  }
};

export const getRdpCommandDiffs = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    let url = `/audits/rdp-command-diffs/?handler_id=${data.handler_id}`;
    if (data.page) url += `&page=${data.page}`;
    if (data.limit) url += `&limit=${data.limit}`;
    if (data.search) url += `&search=${data.search}`;

    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    console.log(e);
    return { data: null, error: e.response?.data?.errors || e.message };
  }
};

export const getWebAppsAccessReportData = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    let url = `/audits/web-apps-access/?page=${data.page}&limit=${data.limit}&search=${data.search}&filter_by=${data.filterBy}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};


export const getGraphReportPDF = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const url = `/audits/graph-data-access/?report_type=${data.report_type}&response_type=${data.response_type}&section=audits&status=download&filter_by=${data.filter_by}&${data.advance_filters}&time_zone=${clientTimezone}`;

    const response = await axios.get(url, config);
    return { data: response, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const SendEmail = async (
  emailAddresses,
  sendEmailOption,
  report_type,
  advanceFilters,
  search,
  filterBy,
  selectedGroups,
  selectedRoles,
  type,
  selectedColumnValues,
  reportName,
  reportDescription,id
) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const checkGroups = Array.isArray(selectedGroups)
      ? selectedGroups
          .map((group) => encodeURIComponent(group))
          .join("&s_group=")
      : encodeURIComponent(selectedGroups);
    const checkRoles = Array.isArray(selectedRoles)
      ? selectedRoles.map((role) => encodeURIComponent(role)).join("&s_role=")
      : encodeURIComponent(selectedRoles);
    const checkType = Array.isArray(type)
      ? type.map((type) => encodeURIComponent(type)).join("&type=")
      : encodeURIComponent(type);
    const checkcolumns =
      Array.isArray(selectedColumnValues) && selectedColumnValues.length > 0
        ? `&columns=${selectedColumnValues
            .map((value) => encodeURIComponent(value))
            .join("&columns=")}`
        : "";

    const emailParams = emailAddresses
      .map((email) => encodeURIComponent(email))
      .join("&emails=");

    const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let url = `/audits/export-reports/?emails=${emailParams}&response_type=${sendEmailOption || ""}&report_type=${report_type || ""}&search=${search || ""}&filter_by=${filterBy}&${advanceFilters}&type=${checkType}&s_group=${checkGroups}&s_role=${checkRoles}&columns=${checkcolumns}&report_name=${reportName}&report_desc=${reportDescription}&&time_zone=${clientTimezone}`;

    if (id && (report_type === "asset_executed_commands_audit" || report_type === "app_executed_commands_audit")) {
      url += `&id=${id}`;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(url, config);

    return { data: response.data, error: null };
  } catch (e) {
    return {
      data: null,
      error: e.response?.data?.errors,
    };
  }
};

export const fetchUserData = async (
  search,
  pageType,
  filter_by,
  response_type
) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const url = `/audits/demo/?search=${search}&report_type=${pageType}&filter_by=${filter_by}&response_type=${response_type}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    throw new Error(`Error fetching user data: ${e.message}`);
  }
};

export const getScheduleReports = async () => {
  try {
    const token = get_jwt_token()
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    }; 
    let url = `/audits/schedule-reports/`
    const response = await axios.get(url, config);
    return { data: response.data, error: null };

  } catch (e) {
    return { data: null, error: e.response.data.errors };
  }
}

export const updateScheduleReports = async (data) => {
  try {
    const token = get_jwt_token()
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    }; 
    let url = `/audits/schedule-reports/`
    const response = await axios.put(url, data, config);
    return { data: response.data, error: null };

  } catch (e) {
    return { data: null, error: e.response.data.errors };
  }
}